import { useEffect, useState , useRef, useContext} from 'react'
import { HubConnectionBuilder } from '@microsoft/signalr';
import { AppContext } from '../../context/AppContext';


const RefreshRealTimeNotifications = ({setRefresh}) => {

    const [ connection, setConnection ] = useState(null);
    const [ message, setMessage ] = useState(null);
    //const dataFetchedRef = useRef(false);

    const {SiteConfig} = useContext(AppContext);

    useEffect(()=>{

        //if (dataFetchedRef.current) return;
       // dataFetchedRef.current = true;

        try{       
        
        const newConnection = new HubConnectionBuilder()
        //.withUrl( SiteConfig.API_NOTIFICATION_HUB_URL + 'notifications')
        .withUrl( SiteConfig.API_NOTIFICATION_HUB_URL)
        .withAutomaticReconnect()
        .build();

        setConnection(newConnection);

        //console.log('======================');
        //console.log(newConnection);
        //console.log('======================');
        //return null;    


        }
        catch(error){console.log(error.message)}

    },[]);


    useEffect(()=>{

        if(connection){
            connection.start()
            .then(result => {
               // console.log("connected");

                //const sNotificationMethodName = "CheckRealTimeRefreshMessage" + SiteConfig.CURRENT_USER_TENANT_ID;    
                const sNotificationMethodName = "RealTimeRefreshMessage" + SiteConfig.CURRENT_USER_TENANT_ID;    
                //const sNotificationMethodName = "newMessage";    

                //connection.on("ReceiveMessage", message =>{
                connection.on(sNotificationMethodName, message =>{
                    setMessage(message);
                    //setNotifications(prevNotifications=> [...prevNotifications, {smessage:message}]);                    
                    setRefresh(prevRefreshData => prevRefreshData +1);

                   //console.log('======================');
                   //console.log(message);
                   //console.log('======================');     

                }
                
                )
            })
            .catch(e=> console.log("connection failed : ",e ) )
        }

    },[connection]);

//    return (
//      <>
//      <h1>Notifications :{message && message.text}</h1>
//      <Button onClick={()=>handleclick("message from client")}>TEST</Button>
//      </>
//    )
}

export default RefreshRealTimeNotifications